import React, { useState } from 'react';
import { getAnimals, getMovies, getProverbs } from '../../repository/QuizShowSpeedRepository';
import { ElapsedTimer } from './ElapsedTimer';

class QuizSpeedHomePage extends React.Component {
  constructor(props) {
    super(props);

    this.movieList = getMovies().sort(() => Math.random() - 0.5);
    this.proverbList = getProverbs().sort(() => Math.random() - 0.5);
    this.animalList = getAnimals().sort(() => Math.random() - 0.5);

    this.state = {
      quizAnswer: "",
      roundResult: {}
    };
  }

  onNextRound(params) {
    switch (params.quizCategory) {
      case "MOVIE":
        this.setState({ quizAnswer: this.movieList.pop() });
        break;
      case "PROVERB":
        this.setState({ quizAnswer: this.proverbList.pop() });
        break;
      case "ANIMAL":
        this.setState({ quizAnswer: this.animalList.pop() });
        break;
      default:
        break;
    }
  }

  onResetRound(params) {
    this.setState({ quizAnswer: "" });
  }

  onFinishRound(params) {
    this.setState({ quizAnswer: "끗", roundResult: params });
    setTimeout(() => this.setState({ quizAnswer: "" }), 3000);
  }

  render() {
    return (
      <div style={{ position: "fixed", left: 0, right: 0, top: 0, bottom: 0, display: "flex" }}>
        <div style={{ flex: 5, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ fontSize: 96 }}>{this.state.quizAnswer}</div>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, background: "#eee" }}>
            <QuizSpeedController
              onNextRound={this.onNextRound.bind(this)}
              onResetRound={this.onResetRound.bind(this)}
              onFinishRound={this.onFinishRound.bind(this)} />
          </div>
        </div>
      </div>
    )
  }
}

const QuizSpeedController = (props) => {
  const [quizCategory, setQuizCategory] = useState("MOVIE");
  const [round, setRound] = useState(0);
  const [maxRound, setMaxRound] = useState(10);
  const [correctCount, setCorrectCount] = useState(0);
  const [passCount, setPassCount] = useState(0);
  const [timerStop, setTimerStop] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);

  const onNextRound = () => {
    (round < maxRound) && props.onNextRound && props.onNextRound({ quizCategory });
    (round < maxRound) && setRound(round + 1);
  };

  const onFinishRound = ({ correctCount, passCount }) => {
    setTimerStop(true);
    props.onFinishRound && props.onFinishRound({ quizCategory, correctCount, passCount, elapsedTime });
  };

  const onResetRound = () => {
    setRound(0);
    setCorrectCount(0);
    setPassCount(0);
    setTimerStop(false);
    props.onResetRound && props.onResetRound();
  };

  const onClickNext = (e) => {
    e.preventDefault();
    if (e.target.className.indexOf("disabled") > -1) return;
    onNextRound();
  };

  const onClickStop = (e) => {
    e.preventDefault();
    if (e.target.className.indexOf("disabled") > -1) return;
    setTimerStop(!timerStop);
  };

  const onClickReset = (e) => {
    e.preventDefault();
    if (e.target.className.indexOf("disabled") > -1) return;
    onResetRound();
  };

  const onClickCorrect = (e) => {
    e.preventDefault();
    const nextCorrectCount = correctCount + 1;
    (nextCorrectCount + passCount <= maxRound) && setCorrectCount(nextCorrectCount);
    (nextCorrectCount + passCount === maxRound) && onFinishRound({ correctCount: nextCorrectCount, passCount });
    onNextRound();
  };

  const onClickPass = (e) => {
    e.preventDefault();
    const nextPassCount = passCount + 1;
    (correctCount + nextPassCount <= maxRound) && setPassCount(passCount + 1);
    (correctCount + nextPassCount === maxRound) && onFinishRound({ correctCount, passCount: nextPassCount });
    onNextRound();
  };

  return (
    <>
      <div style={{ marginTop: 10, fontSize: 48 }}>
        {round} / {maxRound}
      </div>
      <div style={{ marginTop: 10 }}>
        <select className={"custom-select"} onChange={(e) => {
          setQuizCategory(e.target.value);
          onResetRound();
        }}>
          <option value={"MOVIE"}>1.영화 (스피드퀴즈)</option>
          <option value={"ANIMAL"}>2.동물 (몸 + 영어)</option>
          <option value={"PROVERB"}>3.속담 (몸)</option>
        </select>
        <select className={"custom-select"} onChange={(e) => {
          setMaxRound(e.target.value);
          onResetRound();
        }}>
          <option value={10}>10문제</option>
          <option value={20}>20문제</option>
        </select>
      </div>
      <div style={{ marginTop: 10 }}>
        <button className={`btn btn-primary ${round > 0 ? "disabled" : ""}`} onClick={onClickNext}>다음</button>
        &nbsp;
        <button className={`btn btn-info ${round > 0 ? "" : "disabled"}`} onClick={onClickStop}>
          <i className={"bi-caret-right-fill"}></i>
          <i className={"bi-pause-fill"}></i>
        </button>
        &nbsp;
        <button className={`btn btn-danger ${round > 0 ? "" : "disabled"}`} onClick={onClickReset}>
          <i className={"bi-arrow-counterclockwise"}></i>
        </button>
      </div>
      {round > 0 && (
        <div style={{ marginTop: 60 }}>
          <button className={"btn btn-primary"} style={{ minWidth: 100 }} onClick={onClickCorrect}>정답:{correctCount}</button>
          &nbsp;
          <button className={"btn btn-danger"} style={{ minWidth: 100 }} onClick={onClickPass}>패스:{passCount}</button>
          <br />
          <ElapsedTimer
            style={{ fontSize: 24, fontFamily: "monospace" }}
            stop={timerStop}
            onUpdate={({ elapsedTime }) => setElapsedTime(elapsedTime)} />
        </div>
      )}
    </>
  );
};

export { QuizSpeedHomePage };
